import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const DisclaimerTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="Disclaimer of Warranties and Liability" />
      <ol start={6}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`Except as otherwise provided, the Contents of this Web Site shall not be reproduced, ` +
              `published, uploaded, posted, transmitted or otherwise distributed in any way, without the ` +
              `prior written permission of SEAB.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`Modification of any of the Contents or use of the Contents for any other purpose will ` +
              `be a violation of SEAB's copyright and other intellectual property rights. Graphics and image on ` +
              `this Web Site are protected by copyright and may not be reproduced or appropriated in any ` +
              `manner without the written permission of SEAB.`}
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default DisclaimerTermsOfUse;
